var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector74(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 331,
    viewBox: "0 0 75 331",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-232.101 328.673C-213.186 305.285 -209.067 301.578 -189.658 286.762C-184.903 283.132 -175.659 277.42 -164.241 271.965C-160.825 270.331 -157.437 268.848 -154.096 267.489C-130.188 257.795 -103.405 256.427 -76.9546 258.679C-9.46548 264.429 51.4465 227.897 69.2038 172.586C86.9895 117.18 57.7294 55.6535 12.0692 25.6316C6.12792 21.7256 -21.9079 4.49558 -52.6676 1.94861C-149.787 -6.11996 -188.595 87.9563 -217.978 231.1C-218.548 233.884 -220.721 247.142 -221.11 249.955L-232.11 328.683L-232.101 328.673Z",
    stroke: "#A8AEBE",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector74);
export default __webpack_public_path__ + "static/media/vector7-4.02cb28ac5f94bb9e5bc214b78f055c7b.svg";
export { ForwardRef as ReactComponent };